<template>
  <div>
    <template>
      <div class="text-left mb-3">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="third"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Populate Address
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon
                    color="third"
                    medium
                  >
                    mdi-map-marker-outline
                  </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-autocomplete
                    v-model="selectedPrepopAddress"
                    class="pt-3"
                    :items="getGlobalAddressList"
                    item-text="formatted_address"
                    item-value="idx"
                    dense
                    label="Addresses"
                    @change="() => populateAddress()"
                  >
                    <template v-slot:selection="data">
                      {{ typeof data.item !== 'object'
                        ? data.item
                        : `${data.item.street_address}
                          ${data.item.city}
                          ${data.item.state},
                          ${data.item.zip}`
                      }}
                    </template>

                    <template v-slot:item="data">
                      {{ typeof data.item !== 'object'
                        ? data.item
                        : `${data.item.street_address}
                          ${data.item.city} ${data.item.state},
                          ${data.item.zip}`
                      }}
                    </template>
                  </v-autocomplete>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                text
                color="error"
                @click="menu = false"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </template>

    <div class="subtitle-2">What is the company address?</div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          ref="startingAddressField"
          label="Street Address"
          placeholder=""
          class=""
          v-model="formData.streetAddress"
          id="starting_address"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="City"
          placeholder=""
          class=""
          v-model="formData.city"
          id="city"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="State"
          placeholder=""
          class=""
          v-model="formData.state"
          id="state"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field
          label="Zip Code"
          placeholder=""
          class=""
          v-model="formData.zip"
          id="zip"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    value: { type: Object, required: true },
  },
  created() {
    this.fetchGlobalAddressList();
  },
  mounted() {
    if (!this.value.streetAddress) {
      if (this.getCompanyAddress.streetAddress) {
        // use saved company address
        this.formData = this.getCompanyAddress;
        this.setAddress();
      } else {
        // prepop address from quote data
        this.formData = {
          streetAddress: this.getQuoteFacts.billing_address,
          city: this.getQuoteFacts.billing_city,
          state: this.getQuoteFacts.billing_state,
          zip: this.getQuoteFacts.billing_zip,
        };
        this.setAddress();
      }
    } else {
      this.formData = { ...this.value };
    }

    this.initGmap();
  },
  data() {
    return {
      menu: false,
      selectedPrepopAddress: null,
      // Destination data items
      formData: {
        streetAddress: '',
        city: '',
        state: '',
        zip: '',
      },
    };
  },
  computed: {
    ...mapGetters(['getCompanyAddress', 'getQuoteFacts', 'getGlobalAddressList']),
  },
  watch: {
    value(newVal) {
      this.formData = { ...newVal };
    },
  },
  methods: {
    ...mapActions(['updateStoreFormData', 'fetchGlobalAddressList']),
    initGmap() {
      /* eslint-disable */

      let self = this;
      let starting_address_input = this.$refs.startingAddressField?.$el?.querySelector('input'); // document.getElementById("starting_address");
      let starting_address_autocomplete = new google.maps.places.Autocomplete(
        starting_address_input
      );
      starting_address_autocomplete.addListener("place_changed", () => {
        let place = starting_address_autocomplete.getPlace();

        // format Gmap search data
        self.formData.streetAddress = "";
        place.address_components.forEach((component) => {
          const componentType = component.types[0];
          switch (componentType) {
            default: {
              break;
            }
            case "street_number": {
              self.formData.streetAddress = `${component.long_name} ${self.formData.streetAddress}`;
              break;
            }
            case "route": {
              self.formData.streetAddress = `${self.formData.streetAddress} ${component.long_name}`;
              break;
            }
            case "locality": {
              self.formData.city = `${component.long_name}`;
              break;
            }
            case "administrative_area_level_1": {
              self.formData.state = `${component.short_name}`;
              break;
            }
            case "postal_code": {
              self.formData.zip = `${component.short_name}`;
              break;
            }
          }
        });
        
        self.setAddress();
      });
      /* eslint-enable */
    },
    populateAddress() {
      const self = this;
      // right now id based need to change to idx based if filtering by id is not possible --jesse
      const address = (self.getGlobalAddressList
        .filter((a) => a.idx === self.selectedPrepopAddress))
        .shift();

      self.formData = {
        streetAddress: address.street_address,
        city: address.city,
        state: address.state,
        zip: address.zip,
      };

      self.menu = false;
      self.setAddress();
    },
    setAddress() {
      // emit formData to parent and store data there
      this.$emit('registerAddressChange', this.formData);
    },
  },
};
</script>
